export default __webpack_public_path__ + "static/Commercial-Building-Demolition-a00ee93d0b64889567ef1705f4bdbd51.jpg";